import React from "react";
import "../styles/Sidebar.css";

const Sidebar = ({ activeItem, setActiveItem, menuItems, resetSearch }) => {
  const handleItemClick = (item) => {
    // Only allow clicks on non-disabled items
    if (!item.disabled) {
      setActiveItem(item.key);
      if (item.key === "home") {
        resetSearch(); // Reset search when Home is clicked
      }
    }
  };

  return (
    <div className="left-content">
      <aside className="sidebar">
        <nav>
          <ul>
            {menuItems.map((item) => (
              <li
                key={item.key}
                className={`${activeItem === item.key ? "active" : ""} ${
                  item.disabled ? "disabled" : ""
                }`}
                onClick={() => handleItemClick(item)}
              >
                <div className="menu-icon">
                  <img src={item.icon} alt={`${item.label} Icon`} />
                </div>
                <div className="sidebar-label">{item.label}</div>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
